const BgellipsMb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="490"
      height="1000"
      viewBox="0 0 390 1000"
      fill="none"
    >
      <g filter="url(#filter0_f_113_317)">
        <ellipse
          cx="183.256"
          cy="259.346"
          rx="86.2559"
          ry="123.346"
          fill="#EBB268"
          fill-opacity="0.6"
        />
      </g>
      <g filter="url(#filter1_f_113_317)">
        <ellipse
          cx="309.765"
          cy="376.654"
          rx="86.2559"
          ry="123.346"
          fill="#EB6868"
          fill-opacity="0.4"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_113_317"
          x="-103"
          y="-64"
          width="572.512"
          height="646.692"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_113_317"
          />
        </filter>
        <filter
          id="filter1_f_113_317"
          x="-276.491"
          y="-246.692"
          width="1172.51"
          height="1246.69"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="250"
            result="effect1_foregroundBlur_113_317"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default BgellipsMb;
